import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
export const ProductionSystem = props => {
    return (React.createElement(SvgIcon, Object.assign({}, props),
        React.createElement("path", { d: "M11,13 L11,21 L3,21 L3,13 L11,13 Z M21,13 L21,21 L13,21 L13,13 L21,13 Z M11,3 L11,11 L3,11 L3,3 L11,3 Z M21,3 L21,11 L13,11 L13,3 L21,3 Z" })));
};
export default ProductionSystem;
